import { render } from "./filePreviewer.vue?vue&type=template&id=8c51c99c&scoped=true&ts=true"
import script from "./filePreviewer.vue?vue&type=script&lang=ts"
export * from "./filePreviewer.vue?vue&type=script&lang=ts"

import "./filePreviewer.vue?vue&type=style&index=0&id=8c51c99c&scoped=true&lang=css"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c51c99c"]])

export default __exports__